import image1 from '../assets/images/banner1.jpg'
import image2 from '../assets/images/banner2.jpg'

const heroImages = [
  {
    url: image1,
    description_en: "The lush green atmosphere and pleasant ambience     ",
    description_ka: "ಹಚ್ಚ ಹಸಿರಿನ ವಾತಾವರಣ ಮತ್ತು ಆಹ್ಲಾದಕರ ವಾತಾವರಣ",
    caption_en: "Welcome to SPORTI-1",
    caption_ka: "SPORTI-1 ಗೆ ಸುಸ್ವಾಗತ",
    btns:{
      isthere:true,
      link:'/services/sporti1'
    }
  },
  {
    url: image2,
    description_en: "SPORTI takes it's pride in being a one-of-a-kind location serving senior police officials",
    description_ka: "ಹಿರಿಯ ಪೊಲೀಸ್ ಅಧಿಕಾರಿಗಳಿಗೆ ಸೇವೆ ಸಲ್ಲಿಸುವ ಒಂದು ರೀತಿಯ ಸ್ಥಳವಾಗಿರುವುದರಲ್ಲಿ SPORTI ತನ್ನ ಹೆಮ್ಮೆಯನ್ನು ತೆಗೆದುಕೊಳ್ಳುತ್ತದೆ",
    caption_en: "Welcome to SPORTI-2",
    caption_ka: "SPORTI-2 ಗೆ ಸುಸ್ವಾಗತ",
    btns:{
      isthere:true,
      link:'/services/sporti2'
    }
  },
  {
    url: './images/home/home4.jpg',
    description_en: "VRO MANAGED RESTAURANT AT SPORTI-1",
    description_ka: "SPORTI-1 ನಲ್ಲಿ VRO ನಿರ್ವಹಿಸಿದ ರೆಸ್ಟೋರೆಂಟ್",
    caption_en: "",
    caption_ka: "SPORTI ಗೆ ಸುಸ್ವಾಗತ",
    
  },
  {
    url:'/images/home/home3.jpg',
    description_en: "MINI THEATRE FACILITY AT SPORTI-1",
    description_ka: "ಇತರ ಸೌಕರ್ಯಗಳ ಜೊತೆಗೆ SPORTI ನಲ್ಲಿ ನೈರ್ಮಲ್ಯ ಮತ್ತು ಆರಾಮದಾಯಕ ವಸತಿ ಸೌಲಭ್ಯ",
    caption_en: "",
    caption_ka: "SPORTI ಗೆ ಸುಸ್ವಾಗತ",
   
  }
];

export default heroImages;
